import { render, staticRenderFns } from "./OthersFunding.vue?vue&type=template&id=62d94604"
import script from "./OthersFunding.vue?vue&type=script&lang=js"
export * from "./OthersFunding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports